// extracted by css-extract-rspack-plugin
export default {"MoveDashCardActionStyled":"lxOJF"};